export async function getSuggestionDetails(glue_id) {
    const url = "https://gzdkrntut5.execute-api.us-east-2.amazonaws.com/dev/get-suggestion-details";

    try {
        const response = await fetch(`${url}?glue_id=${encodeURIComponent(glue_id)}`);
        if (!response.ok) throw new Error("Failed to fetch");
        const data = await response.json();
        console.log(data);
        return data;
    } catch (err) {
        console.error("API error:", err);
        return null;
    }
}